import React, {Component} from 'react';
import './AppHeader.css';

import dkkLogo from './images/dkk.gif'

import {EventService} from "./services/eventService";

class AppHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            syncing: false,
            unsynchedEvents : 0
        }

        this.getAntallUnsynchedEvents = this.getAntallUnsynchedEvents.bind(this);
        this.resendEvents = this.resendEvents.bind(this);
        this.setSyncing = this.setSyncing.bind(this);

    }

    componentDidMount() {
        window.setInterval(this.getAntallUnsynchedEvents, 1000);
    }

    getAntallUnsynchedEvents() {
        this.setState(() => ({
            unsynchedEvents: EventService.getAntallEvents()
        }));
    }

    resendEvents() {
        this.setSyncing(true);
        EventService.resendEvents();
        setTimeout(this.setSyncing, 2000, false);
    }

    setSyncing(status) {
        this.setState(() => ({
            syncing: status
        }));
    }

    render() {
        const {syncing, unsynchedEvents} = this.state;
        let showEventsSyncedSpan = false;
        let showEventsNotSyncedSpan = false;

        if (unsynchedEvents > 0 && !syncing) {
            showEventsNotSyncedSpan = true;
        }
        if (unsynchedEvents === 0 ) {
            showEventsSyncedSpan = true;
        }
        return (
            <nav className="navbar navbar-default navbar-static-top dkk-header">
                <div className="container">
                    <div className="navbar-brand dkk-logo">
                        <img alt="Dansk Kennel Klub" src={dkkLogo} />
                    </div>
                    <div className="navbar-header dkk-header-text">
                        <span className="visible-xs">DKK lydighed</span>
                        <span className="hidden-xs">DKK resultat registrering for lydighed prøver</span>
                    </div>
                    <div className="dkk-header-status has-spinner">

                        <span className="spinner"><i className="fa fa-refresh fa-spin"></i></span>
                        {
                            showEventsSyncedSpan &&
                            <span className="badge" title="Alle resultater er overført til server.">0</span>
                        }
                        {
                            showEventsNotSyncedSpan &&
                            <span className="badge" onClick={this.resendEvents}  title={unsynchedEvents + " resultater er ikke overført til server. Klikk her for å prøve igen."}>{unsynchedEvents}</span>
                        }


                    </div>
                </div>
            </nav>
        );
    }

}




export default AppHeader;





// WEBPACK FOOTER //
// ./src/AppHeader.js